import React from 'react';
import {
  ListOrdered,
  Shuffle,
  Timer,
  MoveHorizontal,
  BrainCircuit,
  Target,
  Grid,
  Brain,
  Bomb,
  Trophy,
  Pizza,
  Beaker,
  Rocket,
  Scale,
  Thermometer,
} from 'lucide-react';

interface PracticeModeProps {
  title: string;
  description: string;
  icon: string;
  onClick: () => void;
}

const PracticeMode: React.FC<PracticeModeProps> = ({
  title,
  description,
  icon,
  onClick,
}) => {
  const getIcon = (): React.ReactNode => {
    switch (icon) {
      case 'ListOrdered':
        return <ListOrdered className="h-8 w-8 text-indigo-500 dark:text-indigo-400" />;
      case 'Shuffle':
        return <Shuffle className="h-8 w-8 text-sky-500 dark:text-sky-400" />;
      case 'Timer':
        return <Timer className="h-8 w-8 text-amber-500 dark:text-amber-400" />;
      case 'MoveHorizontal':
        return <MoveHorizontal className="h-8 w-8 text-emerald-500 dark:text-emerald-400" />;
      case 'Target':
        return <Target className="h-8 w-8 text-purple-500 dark:text-purple-400" />;
      case 'BrainCircuit':
        return <BrainCircuit className="h-8 w-8 text-rose-500 dark:text-rose-400" />;
      case 'Grid':
        return <Grid className="h-8 w-8 text-teal-500 dark:text-teal-400" />;
      case 'Brain':
        return <Brain className="h-8 w-8 text-orange-500 dark:text-orange-400" />;
      case 'Trophy':
        return <Trophy className="h-8 w-8 text-yellow-500 dark:text-yellow-400" />;
      case 'Pizza':
        return <Pizza className="h-8 w-8 text-orange-500 dark:text-orange-400" />;
      case 'Beaker':
        return <Beaker className="h-8 w-8 text-blue-500 dark:text-blue-400" />;
      case 'Rocket':
        return <Rocket className="h-8 w-8 text-purple-500 dark:text-purple-400" />;
      case 'Scale':
        return <Scale className="h-8 w-8 text-blue-500 dark:text-blue-400" />;
      case 'Thermometer':
        return <Thermometer className="h-8 w-8 text-red-500 dark:text-red-400" />;
      case 'Bomb':
        return (
          <div className="relative">
            <img
              src="/mathbomb-logo.svg"
              alt="Math Bomb"
              className="h-8 w-8 animate-pulse"
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <button
      onClick={onClick}
      className="bg-white dark:bg-slate-800 p-6 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 
        hover:border-indigo-300 dark:hover:border-indigo-500 
        hover:shadow-md transition-all duration-300 flex flex-col items-center text-center"
    >
      <div className="bg-slate-100 dark:bg-slate-700 p-3 rounded-full mb-4">
        {getIcon()}
      </div>
      <h3 className="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-2">{title}</h3>
      <p className="text-slate-600 dark:text-slate-400">{description}</p>
    </button>
  );
};

export default PracticeMode;